import React from "react";
import Aboutus from "./Aboutus";
import LandingPage from "./LandingPage";
import Blog from "./Blog";
import Signup from "./Signup";
import Login from "./Login";
// import Footer from "./Footer";
import Services from "./Services";
import PageNotFound from "./PageNotFound";
import SuccesfulRegistration from "./SuccesfulRegistration";
import Dashboard from "../dashboard/Dashboard";
import ForgotPassword from "./ForgotPassword";
import ResetPasswordToken from "./ResetPasswordToken";
import ResetPassword from "./ResetPassword";
import SuccessfulResetPassword from "./SuccesfulResetPassword";
import { Data } from "./data/data";

// Component Routes from the Dashboard Section
import Todo from "../dashboard/Todo";
import ChatGpt from "../dashboard/ChatGpt";
import Conversion from "../dashboard/Conversion";

import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

const Main = (props) => {
  return (
    <>
      <Router>
        {/* <Header /> */}
        <Routes>
          {/* Default route */}
          <Route path="/" element={<LandingPage data={Data} />} />
          <Route path="/aboutus" element={<Aboutus />} />
          <Route
            path="/services"
            element={<Services Services={Data.services} />}
          />
          <Route path="/blog" element={<Blog />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/login" element={<Login />} />
          <Route
            path="/register-successful"
            element={<SuccesfulRegistration />}
          />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route
            path="/reset-password-token"
            element={<ResetPasswordToken />}
          />
          <Route
            path="/reset-password-successful"
            element={<SuccessfulResetPassword />}
          />
          {/* Dashboard routes */}
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/dashboard/todo" element={<Todo />} />
          <Route path="/dashboard/chat-gpt" element={<ChatGpt />} />
          <Route path="/dashboard/conversion" element={<Conversion />} />

          {/* not found route */}
          <Route path="*" element={<PageNotFound />} />
        </Routes>
        {/* <Footer icons={Data.icons} /> */}
      </Router>
    </>
  );
};
export default Main;
